import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { type ReactNode } from 'react';
import { ToggleSwitch } from '@wix/design-system';
import { Tooltip } from '@wix/wix-base-ui';
import * as coreBi from '#packages/coreBi';

import type { CompRef } from 'types/documentServices';

interface ShowOnAllPagesProps {
  selectedComponents?: Array<CompRef>;
  selectedComponentsTypes?: Array<string>;
  isComponentShowOnAllPages?: boolean;
  disabled?: boolean;
  isPage?: boolean;
  isToggleAllowed: boolean;
  toggleShowOnAllPages?: () => void;
  reportBI?: FunctionFixMe;
  origin?: string;
  className?: string;
  label?: ReactNode;
}

class ShowOnAllPages extends React.Component<ShowOnAllPagesProps> {
  static displayName = 'showOnAllPages';

  static propTypes = {
    selectedComponents: PropTypes.arrayOf(PropTypes.object),
    selectedComponentsTypes: PropTypes.arrayOf(PropTypes.string),
    isComponentShowOnAllPages: PropTypes.bool,
    disabled: PropTypes.bool,
    isPage: PropTypes.bool,
    componentsRestrictions: PropTypes.object,
    toggleShowOnAllPages: PropTypes.func,
    reportBI: PropTypes.func,
    origin: PropTypes.string,
  };

  shouldHideTooltip = () => {
    return (
      !this.props.selectedComponents ||
      !this.props.disabled ||
      this.props.isPage
    );
  };

  handleShowOnAllPages = () => {
    const { isToggleAllowed } = this.props;
    if (this.props.selectedComponents && isToggleAllowed) {
      this.props.toggleShowOnAllPages();

      this.props.reportBI(coreBi.events.rightClickMenu.SHOW_ON_ALL_PAGES, {
        new_status: !this.props.isComponentShowOnAllPages,
        origin: this.props.origin,
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line you-dont-need-lodash-underscore/map
        component_id: _.toString(_.map(this.props.selectedComponents, 'id')),
        component_type: _.toString(this.props.selectedComponentsTypes),
      });
    }
  };

  render() {
    return (
      <label className="row show-on-all-pages-row">
        {this.props.label}
        <Tooltip
          disabled={this.shouldHideTooltip()}
          content="RightClick_Menu_Show_on_All_Pages_Disabled_Tooltip"
          openDelay={600}
        >
          <ToggleSwitch
            disabled={this.props.disabled}
            checked={this.props.isComponentShowOnAllPages}
            onChange={this.handleShowOnAllPages}
            size="medium"
            skin="urgent"
            className={`show-on-all-pages ${this.props.className}`}
          />
        </Tooltip>
      </label>
    );
  }
}

export default ShowOnAllPages;
